import React from 'react';
import { BOLD_BUTTON_GROUP, BOLD_BUTTON, TEXT_SECTION_PRIMARY_TOOLBAR, TEXT_FORMAT_GROUP_RANK, useEditorToolbar } from '@atlaskit/editor-common/toolbar';
import { Show, ToolbarButtonGroup } from '@atlaskit/editor-toolbar';
import { FormatOptions } from '../types';
import { FormatButton } from './Component';
import { formatOptions } from './utils';
var BoldButtonGroup = function BoldButtonGroup(_ref) {
  var children = _ref.children;
  var _useEditorToolbar = useEditorToolbar(),
    editorAppearance = _useEditorToolbar.editorAppearance;
  if (editorAppearance === 'full-page') {
    return /*#__PURE__*/React.createElement(Show, {
      above: "xl"
    }, /*#__PURE__*/React.createElement(ToolbarButtonGroup, null, children));
  }
};
export var boldButtonGroup = function boldButtonGroup(api) {
  return [{
    type: BOLD_BUTTON_GROUP.type,
    key: BOLD_BUTTON_GROUP.key,
    parents: [{
      type: TEXT_SECTION_PRIMARY_TOOLBAR.type,
      key: TEXT_SECTION_PRIMARY_TOOLBAR.key,
      rank: TEXT_FORMAT_GROUP_RANK[BOLD_BUTTON_GROUP.key]
    }],
    component: function component(_ref2) {
      var children = _ref2.children;
      return /*#__PURE__*/React.createElement(BoldButtonGroup, null, children);
    }
  }, {
    type: BOLD_BUTTON.type,
    key: BOLD_BUTTON.key,
    parents: [{
      type: BOLD_BUTTON_GROUP.type,
      key: BOLD_BUTTON_GROUP.key,
      rank: 100
    }],
    component: function component(_ref3) {
      var parents = _ref3.parents;
      var _formatOptions$strong = formatOptions().strong,
        icon = _formatOptions$strong.icon,
        command = _formatOptions$strong.command,
        shortcut = _formatOptions$strong.shortcut,
        title = _formatOptions$strong.title;
      return /*#__PURE__*/React.createElement(FormatButton, {
        api: api,
        parents: parents,
        icon: icon,
        title: title,
        shortcut: shortcut,
        optionType: FormatOptions.strong,
        toggleMarkWithAnalyticsCallback: command
      });
    }
  }];
};